import React from 'react'

const Container = ({ className, children }) => {
    return <div className={`container mx-auto px-8 my-10 lg:my-20 ${className}`}>{children}</div>
}

export default Container
